import { GET_ALL_ADR_USERS } from '../../types'

const INITIAL_STATE = {
  getAllADRUsers: [],
}

const userADRReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_ADR_USERS:
      return {
        ...state,
        getAllADRUsers: payload.data,
        loader: false,
      }

    default:
      return state
  }
}

export default userADRReducer
